import { Skeleton } from "@mui/material";
import { AccordionBody, DescriptionTypography } from "./PathCourseAccordion.styles";
import { ActivityDotNavigation, ActivityItem } from "../../components/CourseActivityCard";
import { SkeletonCard } from "../../components/ModalEditionChange/SkeletonCard";
import type {  ReferencedCourse, ReferencedLearningActivity } from "../../types";


const ActivityAccordion = ({
  course,
  isLoading,
  activities,
  description,
  isStandaloneComponent=false,
  initialActiveLoId
}:{
  course:ReferencedCourse,
  isLoading:boolean,
  activities: ReferencedLearningActivity[] | ActivityItem[],
  description?: string;
  isStandaloneComponent?:boolean,
  initialActiveLoId?: number | null
}) => {

  return (
    <AccordionBody isStandaloneComponent={ isStandaloneComponent }>
      { !isStandaloneComponent && (
        <>
          { isLoading && <Skeleton variant="text" width={ 210 } /> }
          { description && (
            <DescriptionTypography>
              { description }
            </DescriptionTypography>
          ) }
        </>
      ) }
      { isLoading && <SkeletonCard /> }

      { !isLoading && activities?.length > 0 && (
        <ActivityDotNavigation 
          activities={ activities as ActivityItem[] }
          initialActiveLoId={ initialActiveLoId }
          courseId={ course.id }
        />
      ) }
    </AccordionBody>
  );
};

export default ActivityAccordion;
